module.exports = __webpack_public_path__ + "static/media/q&a.1487de00.gif";